import React from 'react';
import { SpRelicDocument } from '../domain/relic';
import DeleteButton from './DeleteButton';
import RelicIcon from './RelicIcon';

interface Props {
  relic: SpRelicDocument,
  onDelete: (id: string) => void
}

const Relic: React.FC<Props> = ({
  relic,
  onDelete
}) => {

  return <div className="shadow-lg rounded flex justify-between items-center p-2">
    <RelicIcon className="h-16 w-16" name={relic.name} />
    <div className="flex-grow mx-2 w-0">
      <h2 className="font-bold text-lg text-gray-700 truncate">{relic.name}</h2>
      <h3 className="text-gray-600 text-sm truncate">{relic.person}</h3>
      <div className="text-gray-500 text-xs">{relic.creationDateTime.toLocaleString()}</div>
    </div>
    <DeleteButton onClick={() => onDelete(relic.$id)} />
  </div>
}

export default Relic;